import React from 'react';

import styled from 'styled-components';

import { RecommendationType } from 'types/recommendations';

import RecommendationCard from './RecommendationCard';
import RecommendationsNotFound from './RecommendationsNotFound';

const CardContainer = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
`;

interface RecommendationListProps {
  data: RecommendationType[] | undefined;
  detailsPath?: string;
  emptyTitle?: string;
  emptyDescription?: string;
}

const RecommendationList = ({ data, detailsPath, emptyTitle, emptyDescription }: RecommendationListProps) => {
  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return <RecommendationsNotFound title={emptyTitle} description={emptyDescription} />;
  }

  return (
    <CardContainer>
      {data.map((r) => (
        <RecommendationCard key={r.id} recommendation={r} detailsPath={detailsPath} />
      ))}
    </CardContainer>
  );
};

export default RecommendationList;
